import { useParams, useLocation } from "react-router-dom";
import { useEffect, useCallback, useState } from "react";
import React from "react";

function User() {
  const routeParams = useParams();
  const API_key = process.env.REACT_APP_API_KEY;
  const [repoList, setRepoList] = useState([]);
  const {state} = useLocation();
  const numberOfRepo =10;
  let user = state.user;

  // eslint-disable-next-line
  const options = {
    method: 'GET',
    headers : {'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${API_key}`
              },
    mode: 'cors'
  };

  const getUsersRepo = useCallback(async () => {

    const url = `https://api.github.com/users/${routeParams.username}/repos`;

    try {
      const result = await fetch(url);

      if(!result.ok) {
        throw new Error(`${result.statusText} (${result.status})`);
      }

      const data = await result.json();
      setRepoList(data);

      
    } catch(error) {
      console.log(error.message);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeParams]);

  useEffect(() => {
    getUsersRepo();
  },[getUsersRepo])

  repoList.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  })

  return (
    <section>
      <div className="container">
        <div className="profile">
            <div className="profile-image">
                <img src={user.avatar_url} alt="Avatar"/>
            </div>
            <h2>{user.login} 
              <a href={user.html_url} target="_blank" rel="noreferrer">
              <i className="fa-solid fa-up-right-from-square"></i>
              </a>
            </h2>
            <div className="info">
              <div className="count">
                <span>{user.public_repos}</span>
                <p>Public Repo</p>
              </div>
              <div className="count">
                <span>{user.followers}</span>
                <p>Followers</p>
              </div>
              <div className="count">
                <span>{user.following}</span>
                <p>Following</p>
              </div>
            </div>
        </div>
        <section className="repo-display">
          <div className="repolist">
            <h4><i className="fa-brands fa-github"></i> Repositories</h4>
            {repoList.length === 0 ? <p>User has no repositories yet</p> : 
              repoList.slice(0,numberOfRepo ).map(repo => (
                  <div className="repo" key={repo.id}>
                      <h3><a href={repo.html_url} target="_blank" rel="noreferrer" >{repo.name}</a></h3>
                      <p>{repo.description}</p>
                  </div>
              ))
            }
          </div>
        </section>
      </div>
    </section>
  )
}

export default User;